import axios from '../axios'

/*
 * 专家管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/mExpert/save',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
// 删除
export const deleteExpert = (data) => {
  return axios({
    url: '/mExpert/delete',
    method: 'post',
    data
  })
};
// 分页查询
export const list = (data) => {
  return axios({
    url: '/mExpert/list',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
export const findExpertBeanById = (data) => {
  return axios({
    url: '/mExpert/findExpertBeanById',
    method: 'post',
    data
  })
};
/**
 * 通过条件查询专家
 * @param data
 * @returns {*|Promise|Promise<unknown>}
 */
export const getExpertByCondition = (data) => {
  return axios({
    url: '/mExpert/getExpertByCondition',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}
/**
 * 查询专家单位
 * @returns {*|Promise|Promise<unknown>}
 */
export const getExpertEnterpriseNameList = () => {
  return axios({
    url: '/mExpert/getExpertEnterpriseNameList',
    method: 'post'
  })
};
/**
 * 查询专业专家数量
 * @param data
 * @returns {*|Promise|Promise<unknown>}
 */
export const getExpertProfessionNum = () => {
  return axios({
    url: '/mExpert/getExpertProfessionNum',
    method: 'post'
  })
};
/**
 * 导出专家数据 exportMExpert
 */
export const exportMExpert = (name, data) => {
  return axios({
    url: "/mExpert/exportMExpert",
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    responseType: 'blob',
    noSerializeData: true,//不序列化参数
    data: data
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}


let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}
// 查询单位列表
export const getExpertDeptList = data => {
  return axios({
    url: 'mExpert/getDeptExtendList',
    method: 'post',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/expert.js